/**
 * Zustand 전역 provider
 * 전역 상태 관리용 루트 컴포넌트
 */
const ZustandProvider = ({ children }) => {
  // 향후 persist, devtools, resetAll 등 추가 가능
  return children;
};

export default ZustandProvider;
